<template>
	<header-block title="Load Tester"></header-block>
	<CustomerLoadWait :customer="!running" />
	<div class="simplePage">
		<p>This page will give you a simple benchmark of system performance, it runs common functions and awaits their return.  
			<!-- Steps include:
			Login
			Customer
			Banking Info
			Transaction
			Transaction Classifications
			Transaction Classification Merchant Rule
			Spending Analysis
			Spending Plans
			Available Vouchers
			Pending Moves -->
		</p>
		<p>Iteration: {{ counter }} of {{ iterations }}</p>
		<p v-if="time">Time taken to complete: {{ time }}ms</p>
		<div class="mt-7">
			<p v-if="times.length > 0">Average: {{ times.reduce((aac, c) => aac + c, 0) / times.length }}ms over {{ times.length }} run(s) </p>
			<v-btn v-if="!running" @click="onLoad" color="primary">Run Again</v-btn>
		</div>
			
	</div>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';

export default {
	mixins: [Services],
	components: {CustomerLoadWait, HeaderBlock},
	data() {
		return {
			iterations: 10,
			counter: 0,
			time: null,
			times:[],
			running: false,
		}
	},
	methods: {
		onLoad: async function() {
			this.useCache = false;
			this.running = true;
			var start = new Date();
			for (var x = 0; x < this.iterations; x++) {	
				this.counter++;
				await this.work(x);
			}
			var end = new Date();
			this.time = end - start;
			console.log('Time taken: ' + this.time + 'ms');
			this.times.push(this.time);
			this.counter = 0;
			this.running = false;
		},
		work: async function(x) {
			var done = false;
			this._login(this.$cookies.get('user'), this.$cookies.get('pass'), () => {
				this._getCustomer(() => {
					this._getBankingInfo(() => {
						var transId = this.bankInfo.accounts[0].transactions[0].id;
						console.log('Transaction ID: ' + transId);
						this._getTransaction(transId, (trans) => {
							this._getTransactionClassifications(() => {
								var cat = this.transactionClassifications[x];
								//alert(JSON.stringify(cat));
								var post = {"alwaysExcludeFromAnalysis":false,
									"merchantName":trans.merchantName,
									"chosenTransactionClassification":{
										"mgClassification":cat.mgClassification.mgClassification,
										"mgSubClassification":cat.mgClassification.mgSubClassification,
										"grandParentClassification":cat.mgClassification.grandParentClassification}}
								//alert(JSON.stringify(post));
								this._updateTransactionClassificationMerchantRule(post, () => {
									this._getSpendingAnalysisStructured(() => {
										this._getSpendingPlansLite(() => {
											this._getAvailableVouchers(() => {
												this._getPendingMoves(() => { 
													done = true;
												});
											});
										});
									});
								});
							});
						});
					});
				});
			});
			while (!done) {
				await new Promise(resolve => setTimeout(resolve, 100));
			}
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

</style>
